<template>
  <div class="config_main_manage_background">
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <config-hang>
          <img slot="config_hang_input_img" src="~assets/img/config/weiyima2.png" alt />
          <input slot="config_hang_input_left" type="text" v-model="thirdPanelInfo.panelAddress"
            placeholder="请输入面板地址(范围:1-254)" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" />
        </config-hang>

        <config-hang>
          <img slot="config_hang_input_img" src="~assets/img/config/weiyima2.png" alt />
          <input slot="config_hang_input_left" type="text" v-model="thirdPanelInfo.keyCount"
            :placeholder="'请输入按键数量(范围:1-' + keyCountMax + ')'" onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')" />
        </config-hang>

        <config-hang>
          <img slot="config_hang_input_img" src="~assets/img/config/hostname.png" alt />
          <input class="add_device_input" slot="config_hang_input_left" type="text" v-model="thirdPanelInfo.remark"
            placeholder="请输入设备备注" />
        </config-hang>

        <div class="xiaotishi_style">面板扩展模块:{{ extensionTitle }}</div>
        <div class="xiaotishi_style">总键位:{{ usableInfo.capacityTotal }} 已用:{{ usableInfo.capacityUsed }} 剩余:{{
          usableInfo.capacityRemain }}</div>
        <div class="xiaotishi_style">小提示:当前页面会自动生成一个可用地址和建议名称,建议优先使用.</div>

        <div class="public_config_que_ren_btn" @click="saveThirdPanelBtnHandle">确认添加</div>
      </div>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";

export default {
  data() {
    return {
      query: this.$route.query,
      usableInfo: {
        usablePanelAddress: "",
        capacityTotal: 0,
        capacityUsed: 0,
        capacityRemain: 0,
        suggestedPanelName: ""
      },
      thirdPanelInfo: {
        panelAddress: "",
        keyCount: "",
        remark: ""
      }
    };
  },
  components: {
    configHang
  },
  computed: {
    extensionTitle() {
      return (this.query.productName || "面板扩展模块") + "(" + (this.query.borderInnerAddress || this.query.address || "") + "|" + (this.query.program || "") + ")";
    },
    keyCountMax() {
      let capacityRemain = Number(this.usableInfo.capacityRemain);
      if (!capacityRemain || capacityRemain <= 0) {
        return 0;
      }
      return capacityRemain;
    }
  },
  methods: {
    getUsableInfo() {
      this.$request({
        method: "post",
        url: "/panelExtension/findPanelExtensionUsableInfo",
        data: {
          token: this.$store.state.token,
          extensionProductId: this.query.productId
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            return;
          } else {
            this.usableInfo = res.data.data;
            this.thirdPanelInfo.panelAddress = this.usableInfo.usablePanelAddress;
            this.thirdPanelInfo.keyCount = "";
            this.thirdPanelInfo.remark = this.usableInfo.suggestedPanelName;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    saveThirdPanelBtnHandle() {
      if (this.thirdPanelInfo.panelAddress === "" || this.thirdPanelInfo.panelAddress <= 0 || this.thirdPanelInfo.panelAddress > 254) {
        this.$toast("地址范围1-254!");
        return;
      } else if (this.keyCountMax <= 0) {
        this.$toast("剩余键位不足!");
        return;
      } else if (this.thirdPanelInfo.keyCount === "" || this.thirdPanelInfo.keyCount <= 0 || Number(this.thirdPanelInfo.keyCount) > this.keyCountMax) {
        this.$toast("按键数量范围1-" + this.keyCountMax + "!");
        return;
      } else if (Number(this.thirdPanelInfo.keyCount) > Number(this.usableInfo.capacityRemain)) {
        this.$toast("按键数量不能大于剩余键位!");
        return;
      } else if (this.thirdPanelInfo.remark === "") {
        this.$toast("设备备注不能为空！");
        return;
      } else if (this.thirdPanelInfo.remark.length > 20) {
        this.$toast("添加失败,名称不能超过20个字符哦~");
        return;
      }
      this.$request({
        method: "post",
        url: "/panelExtension/saveThirdPanel",
        data: {
          token: this.$store.state.token,
          extensionProductId: this.query.productId,
          panelAddress: Number(this.thirdPanelInfo.panelAddress),
          keyCount: Number(this.thirdPanelInfo.keyCount),
          remark: this.thirdPanelInfo.remark
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            return;
          } else {
            this.$showTipsToast(1, "添加成功", true);
            this.updataPanelExtensionThirdPanelListData(res.data.data);
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    updataPanelExtensionThirdPanelListData(data) {
      data = data || {};
      let storeData = this.$store.state.configinfo.panelExtensionThirdPanelListData;
      let thirdPanelListData = {
        extensionProductId: this.query.productId,
        offLineList: [],
        onLineList: [],
        capacityTotal: 0,
        capacityUsed: 0,
        capacityRemain: 0,
        errorMsg: ""
      };

      // 与有线产品添加设备保持一致: 成功后先更新Vuex缓存, 返回列表页不再重新请求阻塞接口.
      if (storeData.extensionProductId === this.query.productId) {
        thirdPanelListData = {
          extensionProductId: storeData.extensionProductId,
          offLineList: (storeData.offLineList || []).slice(),
          onLineList: (storeData.onLineList || []).slice(),
          capacityTotal: storeData.capacityTotal || 0,
          capacityUsed: storeData.capacityUsed || 0,
          capacityRemain: storeData.capacityRemain || 0,
          errorMsg: storeData.errorMsg || ""
        };
      }
      if (data.addProduct) {
        //添加到最上面
        thirdPanelListData.offLineList.unshift(data.addProduct);
      }
      thirdPanelListData.capacityTotal = data.capacityTotal || 0;
      thirdPanelListData.capacityUsed = data.capacityUsed || 0;
      thirdPanelListData.capacityRemain = data.capacityRemain || 0;

      this.$store.dispatch(
        "asyUpdataPanelExtensionThirdPanelListData",
        thirdPanelListData
      );
    }
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    this.getUsableInfo();
  }
};
</script>

<style>
div .add_device_input {
  ime-mode: auto;
}
</style>
